import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["activeClassName", "activeStyle", "children", "className", "exact", "style", "to"];
import PropTypes from 'prop-types';
import cx from 'classnames';
import UIRouterButton from './UIRouterButton';
import useIsActive from './internal/useIsActive';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * A [`UIButton`](https://private.hubteamqa.com/uicomponents-storybook/?path=/docs/uicomponents-button-uibutton--primary)
 * type component with router support. This component supports `NavButton`'s `activeClassName` and `activeStyle` props.
 * You should avoid creating custom "active" variants of this component because they aren't supported by the base component. If you find
 * yourself needing to use those, you should file a Canvas Design request to change the component and use the default "active" behavior
 * and appearance in the short-term.
 */
export default function UIRouterNavButton(props) {
  const {
      activeClassName,
      activeStyle,
      children,
      className,
      exact,
      style,
      to
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const active = useIsActive(to, exact);
  const classes = cx(className, activeClassName && {
    [activeClassName]: active
  });
  return /*#__PURE__*/_jsx(UIRouterButton, Object.assign({}, rest, {
    className: classes,
    to: to,
    style: Object.assign({}, style, active ? activeStyle : null),
    children: children
  }));
}
UIRouterNavButton.propTypes = Object.assign({}, UIRouterButton.propTypes, {
  activeClassName: PropTypes.string,
  activeStyle: PropTypes.object,
  className: PropTypes.string,
  exact: PropTypes.bool.isRequired,
  style: PropTypes.object.isRequired
});
UIRouterNavButton.defaultProps = Object.assign({}, UIRouterButton.defaultProps, {
  exact: false,
  style: {}
});